export default {"src":"/_next/static/media/gr.6e914225.svg","height":341,"width":512,"blurWidth":0,"blurHeight":0};